import type { GameManifest } from '@adgf/shared';
import { GameStatus } from '@adgf/shared';

const manifest: GameManifest = {
  id: 'b8c9d0e1-f2a3-4b4c-9d0e-1f2a3b4c5d6e',
  slug: 'daily-tile-match',
  title: 'Daily Tile Match',
  description: 'Tap stacked tiles into the 7-slot tray. Match 3 to clear them. One new puzzle every day. How far can you go?',
  version: '0.1.0',
  template_id: 'tile-match',
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'hard',
  duration: 180,
  features: ['daily-puzzle', 'tile-match', 'stacked', 'streak', 'single-session'],
  entrypoint: 'phaser:daily-tile-match',
  analytics_schema: {
    events: ['game_open', 'game_start', 'tile_tap', 'tile_clear', 'tile_stack_full', 'puzzle_solved', 'puzzle_failed', 'daily_streak'],
  },
};

export default manifest;
